<template>
  <page-header-wrapper>
    <!-- <template v-slot:content>
        <div class="page-header-content">
          <div class="avatar">
            <a-avatar size="large" :src="avatar" />
          </div>
          <div class="content">
            <div class="content-title">
              111
              {{ timeFix }}，{{ nickname }}<span class="welcome-text"></span>
            </div>
            <div>{{ postGroup }} | {{ user.dept && user.dept.deptName }}</div>
          </div>
        </div>
      </template> -->
    <div class="home">
      <!-- <a-card :bordered="false">
          <p>Card content</p>
          <p>Card content</p>
          <p>Card content</p>
        </a-card> -->
      <div class="home_card">
        <!-- <div class="card_item">
            待预约：<span>{{ statistics01.orderToBeSent }}</span>
          </div>
          <div class="card_item">
            待确认：<span>{{ statistics01.orderToBeSent }}</span>
          </div> -->
        <div class="card_item" @click="handleLook('/workOrder/workerThree')">
          待派单：<span>{{ info.toBeSentCount }}</span>
        </div>
        <div class="card_item" @click="handleLook('/workOrder/workerTen')">
          已拒绝：<span>{{ info.declinedCount }}</span>
        </div>
        <div class="card_item" @click="handleLook('/workOrder/workerFive')">
          待接单：<span>{{ info.pendingCount }}</span>
        </div>
        <div class="card_item" @click="handleLook('/workOrder/workerSix')">
          待试压：<span>{{ info.toBePressedCount }}</span>
        </div>
        <div class="card_item" @click="handleLook('/workOrder/workerSeven')">
          待审核：<span>{{ info.submittedCount }}</span>
        </div>
        <div class="card_item" @click="handleLook('/workOrder/workerEight')">
          已完成：<span>{{ info.completedCount }}</span>
        </div>
        <div class="card_item" @click="handleLook('/workOrder/workerNine')">
          已作废：<span>{{ info.haveBeenCancelledCount }}</span>
        </div>
      </div>
      <div class="home_c">
        <div class="home_c_l">
          <div class="home_c_l_t">
            <div><a-icon type="user" />区域信息</div>
            <div class="home_c_l_p">
              <!-- <a-select
                show-search
                :allowClear="true"
                v-model="queryParam.regionId"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
                style="width: 100%"
              >
                <a-select-option v-for="d in quList" :key="d.id">{{ d.name }}</a-select-option>
              </a-select> -->
              {{ statistics01.name }}
            </div>
          </div>
          <div class="home_c_l_i">
            负责人:<span>{{ statistics01.contacts }}</span>
          </div>
          <div class="home_c_l_i">
            联系电话：<span>{{ statistics01.mobile }}</span>
          </div>
          <div class="home_c_l_i">
            详细地址：<span
              >{{ statistics01.province }}{{ statistics01.city }}{{ statistics01.area }}{{ statistics01.address }}</span
            >
          </div>
        </div>
        <div class="home_c_r">
          <div class="home_c_r_l">
            <div class="home_c_r_l_t">
              <a-icon type="sound" />
              消息
            </div>
            <div class="home_c_r_l_c" v-for="(item, index) in noticeList" :key="index" @click="handleNew(item)">
              {{ item.newsTitle }} <span>{{ item.createTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="home_p">
        <div class="item">
          <img src="@/assets/images/fen.png" alt="" />
          <div>
            <span> {{ statistics01.tenantCount }}</span>
            <div>经销商</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/images/yan.png" alt="" />
          <div>
            <span>{{ statistics01.examinerCount }}</span>
            <div>验收员</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/images/shui.png" alt="" />
          <div>
            <span>{{ statistics01.waterCount }}</span>
            <div>水工</div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/images/ding.png" alt="" />
          <div>
            <span> {{ statistics01.orderCount }}</span>
            <div>订单</div>
          </div>
        </div>
      </div>
      <div class="home_f">
        <div class="home_y">
          <div class="home_y_l">
            <div class="home_y_u">
              <div class="home_y_1">省</div>
              <div class="home_y_2">市</div>
              <div class="home_y_3">区</div>
              <div class="home_y_4">创建时间</div>
            </div>
            <div class="home_y_u_o">
              <div class="home_y_u home_y_p" v-for="(item, index) in usePoints" :key="index">
                <div class="home_y_1">{{ item.province }}</div>
                <div class="home_y_2">{{ item.city }}</div>
                <div class="home_y_3">{{ item.area }}</div>
                <div class="home_y_4">{{ item.createTime }}</div>
              </div>
            </div>
          </div>
          <div class="home_y_r">
            <twoPie :chartData="chartData1"></twoPie>
            <div class="home_y_r_p">
              <div class="home_y_r_o">
                管理区域
              </div>
               {{ usePoints.length }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="home_f">
        <div class="home_f_h"><a-icon type="line-chart" />数据统计</div>
        <div class="home_f_r">
          <div class="home_f_l">
            <div class="home_f_l_t">
              <div></div>
              近半年试压服务统计单
            </div>
            <BarChart :chartData="chartData"></BarChart>
          </div>
          <div class="home_f_l">
            <div class="home_f_l_t">
              <div></div>
              试压情况系统
            </div>
            <Pie :chartData="chartData1"></Pie>
          </div>
        </div>
      </div> -->
      <!-- <div v-show="show">{{ stortIndex }}</div> -->
      <Detail ref="Detail"></Detail>
    </div>
  </page-header-wrapper>
</template>
  
  <script>
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import { ownership } from '@/api/pressure/home'
import { noticeWay } from '@/api/system/notice'
import { reginCount } from '@/api/pressure/dispatch'
//   import BarChart from './Charts/barChart.vue'
//   import mapChart from './Charts/map.vue'
//   import Pie from './Charts/pie.vue'
import twoPie from '../../Charts/twoPie.vue'
import Detail from '../../system/notice/detail.vue'
export default {
  name: 'Index',
  components: {
    twoPie,
    Detail,
  },
  data() {
    return {
      chartData: {},
      roleGroup: {},
      postGroup: {},
      statistics01: {},
      usePoints: [],
      data: [],
      show: false,
      queryParam: {},
      info: {},
      chartData1: {
        arr: [
          { value: 1, name: '河南' },
          { value: 2, name: '北京' },
          { value: 3, name: '山东' },
        ],
      },
      noticeList: [],
      quList: [],
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname', 'index']),
    //   stortIndex() {
    //     console.log(this.$route, '测试数据====')
    //     const path = this.$route.path
    //     if (path === '/index') {
    //       this.getUser()
    //     }
    //     return this.$route.path
    //   },
  },
  // watch: {
  //   index()
  // },
  created() {
    console.log('测试梳理===')
    this.getUser()
    this.getCount()
    this.data = [
      {
        key: '1',
        name: 'John Brown',
        money: '￥300,000.00',
        address: 'New York No. 1 Lake Park',
      },
      {
        key: '2',
        name: 'Jim Green',
        money: '￥1,256,000.00',
        address: 'London No. 1 Lake Park',
      },
      {
        key: '3',
        name: 'Joe Black',
        money: '￥120,000.00',
        address: 'Sidney No. 1 Lake Park',
      },
    ]
  },
  mounted() {
    console.log('测试梳理===111')
  },
  methods: {
    getCount() {
      reginCount().then((res) => {
        console.log(res, '测试订单张贴信息')
        this.info = res.data
      })
    },
    handleLook(e) {
      this.$router.push(e)
    },
    // 点击更新
    handleNew(e) {
      this.$nextTick(() => {
        this.$refs.Detail.init(e)
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 获取用户信息
    getUser() {
      ownership().then((res) => {
        console.log(res, '的点点滴滴=========测试首页数据')
        this.statistics01 = res.data
        this.usePoints = res.data.usePoints
        const arr = []
        const leg = this.usePoints.length
        const provinceCount = {}
        this.usePoints.forEach((item) => {
          const province = item.province
          provinceCount[province] = (provinceCount[province] || 0) + 1
        })
        console.log(provinceCount, '顶顶顶密码')
        // 2. 转换成目标数组格式
        const result = Object.entries(provinceCount).map(([name, value]) => ({
          name,
          value,
        }))
        console.log(result, 'resultresult')
        // obj.x = res.data.statisticalMonthlyData01.map((v) => v.mon)
        // obj.y = res.data.statisticalMonthlyData01.map((v) => v.orderCount)
        // this.chartData = obj
        // const objs = this.statistics01
        this.chartData1 = {
          arr: result,
        }
      })
      noticeWay({ pageNum: 1, pageSize: 4 }).then((res) => {
        console.log(res, 'resresres')
        this.noticeList = res.data.records
        console.log(this.noticeList, 'noticeListnoticeList')
      })
    },
    onSponsorTabChange(key, type) {
      this[type] = key
    },
  },
}
</script>
  
  <style lang="less" scoped>
//   @import './index.less';
.home {
  padding: 8px;
  padding-bottom: 0;
  height: 81.5vh;
  overflow-y: auto;
  .ant-card-grid {
    border: none !important;
    // background: red;
  }
  .home_card {
    // background: red;
    display: flex;
    align-items: center;
    background: #fff;
    height: 80px;
    border-radius: 8px;
    cursor: pointer;
    transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
    &:hover {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
    }
    // flex-wrap: nowrap;
    .card_item {
      display: inline-block;
      width: 14.2%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      cursor: pointer;
      border-right: 1px solid #e5e5e5;
      &:last-child {
        border: none;
      }
      span {
        font-weight: bold;
      }
    }
  }
  .home_c {
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    .home_c_l {
      width: 40%;
      background: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      margin-right: 10px;
      height: 205px;
      cursor: pointer;
      padding: 20px;
      &:hover {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
      }
      transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
      .home_c_l_t {
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin-bottom: 10px;
        .home_c_l_p {
          width: 200px;
          // background: red;
          text-align: right;
        }
      }
      .home_c_l_i {
        // height: 30px;
        padding: 8px 0;
        border-bottom: 1px solid #e5e5e5;
        span {
          color: #1a73e8;
          font-weight: 800;
        }
      }
    }
    .home_c_r {
      flex: 1;
      // height: 185px;
      height: 205px;
      cursor: pointer;
      padding: 20px;
      background: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      display: flex;
      padding: 20px;
      &:hover {
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
      }
      transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
      .home_c_r_l_t {
        font-size: 18px;
        font-weight: 500;
        border-right: 1px solid #e5e5e5;
      }
      .home_c_r_l {
        // width: 49%;
        width: 100%;
        margin-right: 20px;
        .home_c_r_l_c {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  .home_p {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    .item {
      height: 80px;
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-radius: 20px;
      span {
        font-size: 20px;
      }
      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
    }
  }
  .home_f {
    margin-top: 10px;
    // display: flex;
    .home_y {
      display: flex;
      .home_y_l {
        background: #fff;
        border-radius: 16px;
        overflow: hidden;
        width: 50%;
        height: 400px;
        .home_y_u {
          height: 50px;
          background: #e5eeff;
          display: flex;
          align-items: center;
          text-align: center;
          font-size: 16px;
          div {
            display: -webkit-box;
            -webkit-line-clamp: 1; /* 限制显示的行数为3 */
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .home_y_1 {
            width: 20%;
          }
          .home_y_2 {
            width: 20%;
          }
          .home_y_3 {
            width: 20%;
          }
          .home_y_4 {
            flex: 1;
          }
        }
        .home_y_p {
          height: 40px;
          font-size: 14px;
          background: transparent;
        }
        .home_y_u_o {
          height: 380px;
          // background: red;
          overflow-y: auto;
          /* 滚动条整体部分 */
          &::-webkit-scrollbar {
            width: 0; /* 滚动条的宽度 */
          }
        }
      }
      .home_y_r {
        background: #fff;
        border-radius: 16px;
        margin-left: 20px;
        flex: 1;
        height: 400px;
        position: relative;
        .home_y_r_p {
          position: absolute;
          top: 50%;
          left: 50%;
          font-size: 20px;
          text-align: center;
          transform: translate(-50%, -50%);
          .home_y_r_o{
            color: #333;
            font-weight: bold;
          }
        }
      }
    }

    .home_f_h {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .home_f_r {
      display: flex;
      justify-content: space-between;
      .home_f_l {
        width: 49%;
        background: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        height: 442px;
        transition: box-shadow 0.3s ease-in-out; /* 平滑过渡阴影效果 */
        &:hover {
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.09); /* 悬停时的阴影 */
        }
        .home_f_l_t {
          padding-left: 20px;
          margin-top: 20px;
          font-size: 18px;
          display: flex;
          color: #000;
          font-weight: bold;
          align-content: center;
          div {
            width: 4px;
            height: 18px;
            background: #1a73e8;
            margin-right: 15px;
            border-radius: 2px;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
.ant-layout-content {
  margin: 0 !important;
}
</style>
  